<template>
    <div class="plk_menu">
        <img class="logo" :src="`${publicPath}images/logo-blanco.png`"/>
        <router-link :to="{ name: design}">{{$t('designer.menu.design')}}</router-link>
        <router-link :to="{ name: styles}">{{$t('designer.menu.styles')}}</router-link>
        <router-link :to="{ name: javascript}">{{$t('designer.menu.javascript')}}</router-link>
        <router-link :to="{ name: connections}">{{$t('designer.menu.connections')}}</router-link>
    </div>
</template>

<script>
import i18n from './i18n'
import { DESIGN_VIEW, CONNECTIONS_VIEW, CSS_VIEW, JS_VIEW } from '@/router'
export default {
  name: 'design',
  components: {
  },
  data () {
    return {
      design: DESIGN_VIEW,
      styles: CSS_VIEW,
      javascript: JS_VIEW,
      connections: CONNECTIONS_VIEW,
      publicPath: process.env.BASE_URL
    }
  },
  methods: {
    onInitComponent () {
      this.$servicesPLK.translation.init(i18n, { overwrite: false })
    }
  }
}
</script>

<style scoped lang="scss">
.plk_menu .logo {
    display: block;
    margin-bottom: 20px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding-top: 5px;
}
.plk_menu a {
    color: white;
    text-decoration: none;
    display: block;
    font-weight: bold;
    padding: 5px;
    font-size: 0.9em;
}
.plk_menu a:hover {
    color: #23001e;
}
.plk_menu a.router-link-exact-active {
    color: #ffba49;
}
@media (max-width: 700px) {
    .plk_menu a {
        padding-left: 0px;
        padding-right: 0px;
    }
}
@media (max-width: 550px) {
    .plk_menu .logo {
        height: 50px;
        width: auto;
        margin-bottom: 10px;
    }
    .plk_menu a {
        text-align: center;
    }
}
</style>
